import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http'
import { Constant } from './constants';
import * as fromModels from './models'; // Adjust the path './models' to the correct location of the fromModels namespace
import { Observable, of } from 'rxjs';
import { Utils } from './utils';


@Injectable({
  providedIn: 'root'
})
export class InitService {

  private httpClient: HttpClient
  private readonly configCacheKey = 'app.config.cache.v1';
  private readonly configCacheTtlMs = 10 * 60 * 1000;
  constructor(private handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
   }

   getConfigLocal() {
    return new Promise<any>((resolve, reject) => {
      Constant.updateConfig({   
        "env": "DEV",
        "apibaseurl": "https://localhost:44378/api/",    
        "clientid": "bf51b1bf-f99d-4aa6-b5b5-eacfc0ec1eb2",
        "instance": "https://login.microsoftonline.com/",
        "tenant": "rockco.onmicrosoft.com",
        "appinsightkey": "b1286596-73cc-479c-8cd6-8790974ced0f",
        "scope": "https://supervisionreport.dev.rockco.com/default",
        "apienvurl":"https://api.dev.rockco.com/",
         "dynamiccrmbaseurl":"https://rcmceuat2.api.crm.dynamics.com/",
        "superusers":"dbhagavan@rocko.com,MMThomas@rockco.com",
        "compusers":"111NGhiwala@rockco.com",
        "chequeusers":"MMThomas@rockco.com",
        "latestmonth":"1",
        "latestyr":"2022",
        "nfsreportenable":"Y"
      });
      resolve(Constant.config);
    }).catch(err => {
      console.log("Error occured while initializing service. Detail: " + JSON.stringify(err));
    });
  }

  getConfig() {
    return new Promise<any>((resolve, reject) => {
      const cached = this.getCachedConfig();
      if (cached) {
        Constant.updateConfig(cached);
        resolve(cached);
        return;
      }

      let _url = '/api/config';
      //let _url = "http://localhost:63894/api/config";
      this.httpClient.get(_url).toPromise().then(res => {
        Constant.updateConfig(res as any);
        this.setCachedConfig(res as any);
        resolve(res);
      })
    }).catch(err => {
      console.log("Error occured while initializing service. Detail: " + JSON.stringify(err));
    });
  }

  private getCachedConfig(): any | null {
    try {
      const raw = sessionStorage.getItem(this.configCacheKey);
      if (!raw) {
        return null;
      }

      const parsed = JSON.parse(raw) as { expiresAt?: number; value?: any };
      if (!parsed?.expiresAt || parsed.expiresAt < Date.now() || !parsed.value) {
        sessionStorage.removeItem(this.configCacheKey);
        return null;
      }

      return parsed.value;
    } catch {
      sessionStorage.removeItem(this.configCacheKey);
      return null;
    }
  }

  private setCachedConfig(config: any): void {
    try {
      const payload = {
        expiresAt: Date.now() + this.configCacheTtlMs,
        value: config
      };
      sessionStorage.setItem(this.configCacheKey, JSON.stringify(payload));
    } catch {
      // Ignore storage errors and continue with in-memory config only.
    }
  }

 


  
}
